import { useEffect, useState, useCallback } from "react";
import { io } from "socket.io-client";
import { useLoginUser } from "../useLoginUser";
import { showToast } from "../../components";
import { WORKFORCE_SOCKET_API_URL } from "../../redux/apiConfig";
import { updateTotalCountToStore } from "../../utils/wf-notifications";

const WF_SOCKET_URL = WORKFORCE_SOCKET_API_URL || "http://localhost:8080";
let notificationEventsWF = [
  "notifications",
  "server:timesheet_submission",
  "server:timesheet_approval",
  "server:timesheet_rejection",
  "server:invoice_creation",
  "server:placement_closing_alert",
  "server:new_incoming_placement",
];

//add here if extra sockets are needed in future
//to manage multiple sockets for different purposes
let socketInstance = {
  workforce: null,
};
const getSocketURL = (socketFor) => {
  switch (socketFor) {
    case "workforce":
      return WF_SOCKET_URL;
    default:
      return null;
  }
};

//to create socket connection for workforce or others
const createSocket = (userId, socketFor) => {
  if (!userId) return null;
  const ENV = import.meta.env.VITE_APP_ENV || "local";
  let path =
    ENV === "local" ? `/${ENV}/socket.io` : `/${socketFor}/${ENV}/socket.io`;
  if (!socketInstance[socketFor]) {
    let socketURL = getSocketURL(socketFor);
    socketInstance[socketFor] = io(socketURL, {
      path,
      withCredentials: true,
      query: { userId },
      reconnectionAttempts: 5,
      timeout: 10000,
      autoConnect: true,
    });

    socketInstance[socketFor].on("connect", () => {
      console.log(
        `WF: 🔌 Connected to socket server: UserId: ${userId} ---`,
        socketInstance[socketFor].id,
      );
      updateTotalCountToStore({ userId });
    });

    socketInstance[socketFor].on("disconnect", () => {
      console.log(`WF:❌ Disconnected from socket`);
    });

    notificationEventsWF?.forEach((event) => {
      socketInstance[socketFor].on(event, (data) => {
        showToast(
          data.message ? `${data.message}` : "Notification Received",
          "primary",
        );

        updateTotalCountToStore({ userId });
        console.log(`WF:📨 Notification data for ${event}:`, data);
      });
    });
      socketInstance[socketFor].on("server:banking_message", (data) => {
        showToast(
          data.message ? `${data.message}` : "Notification Received",
          "primary",
        );
        console.log(`WF:📨 Notification data for ${event}:`, data);
      });

    socketInstance[socketFor].on("connect_error", (err) => {
      // console.error("⚠️ Socket Connection error:", err);
    });
  }

  return socketInstance[socketFor];
};

//to disconnect a specific socket
const disconnectSocket = (socketFor) => {
  if (socketInstance[socketFor]) {
    socketInstance[socketFor].disconnect();
    socketInstance[socketFor] = null;
  }
};

//to initialize a specific socket
export const useWfSocket = (socketFor = "workforce") => {
  const { loginUserUiid } = useLoginUser();
  const [socket, setSocket] = useState(null);

  useEffect(() => {
    const userId = loginUserUiid;
    if (!userId) {
      console.warn("WF:⚠️ User ID not found for socket conection.");
      return;
    }
    const s = createSocket(userId, (socketFor = "workforce"));
    setSocket(s);

    return () => {
      disconnectSocket(socketFor);
    };
  }, [loginUserUiid]);

  const emitEvent = useCallback(
    (eventName, data) => {
      if (socket && socket.connected) {
        socket.emit(eventName, data);
      } else {
        console.warn(`WF:⚠️ Cannot emit, socket not connected. Event: ${eventName}`);
      }
    },
    [socket],
  );

  const listenEvent = useCallback(
    (eventName, callback) => {
      // if (socket && socket.connected) {
      if (socket) {
        socket.on(eventName, callback);
      } else {
        console.warn(`WF:⚠️ Cannot listen, socket not connected. Event: ${eventName}`);
      }
    },
    [socket],
  );

  return {
    socket,
    emitEvent,
    listenEvent,
    disconnectSocket,
  };
};
